import { render, staticRenderFns } from "./CodeSnippet.vue?vue&type=template&id=63ff6410&scoped=true"
import script from "./CodeSnippet.vue?vue&type=script&lang=js"
export * from "./CodeSnippet.vue?vue&type=script&lang=js"
import style0 from "./CodeSnippet.vue?vue&type=style&index=0&id=63ff6410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ff6410",
  null
  
)

export default component.exports